import { City, District } from '@/models/City';
import { SettingsHomepageItem } from '@/models/Settings';
import { WindowDispatchEvent } from './WindowDispatchEvent';
import { STORAGE_KEY } from './storageKeys';
import { readMigratedItem, writeMigratedItem } from './crypto/storageMigration';
import { safeLocalStorage } from './safeStorage';

export const presetOtherCityId = 192; // Default city ID for "Other City"
export const presetOtherCityTargetPath = '/other-city'; // Default target path for "Other City"

export async function loadSettings() {
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_TOP_LEFT_ITEMS));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_TOP_RIGHT_ITEMS));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_CITIES));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_DISTRICTS));
}

export function getTopLeftItems() {
  try {
    return JSON.parse(
      readMigratedItem(safeLocalStorage, STORAGE_KEY.TOP_LEFT_ITEMS) || '[]',
    ) as SettingsHomepageItem[];
  } catch {
    return [];
  }
}

export function getTopRightItems() {
  try {
    return JSON.parse(
      readMigratedItem(safeLocalStorage, STORAGE_KEY.TOP_RIGHT_ITEMS) || '[]',
    ) as SettingsHomepageItem[];
  } catch {
    return [];
  }
}

export function getCities() {
  try {
    const citiesValue: City[] = JSON.parse(
      readMigratedItem(safeLocalStorage, STORAGE_KEY.CITIES) || '[]',
    );
    return citiesValue;
  } catch (e) {
    return [];
  }
}

export function getDistricts() {
  try {
    const districtsValue: District[] = JSON.parse(
      readMigratedItem(safeLocalStorage, STORAGE_KEY.DISTRICTS) || '[]',
    );
    return districtsValue;
  } catch (e) {
    return [];
  }
}

export function getOtherCityId() {
  try {
    const otherCityId: number = parseInt(
      JSON.parse(
        readMigratedItem(safeLocalStorage, STORAGE_KEY.OTHER_CITY_ID) ||
          presetOtherCityId.toString(),
      ),
      10,
    );
    return otherCityId;
  } catch (e) {
    return 0;
  }
}

export function getOtherCityTargetPath() {
  try {
    const otherCityTargetPath: string | undefined = JSON.parse(
      readMigratedItem(safeLocalStorage, STORAGE_KEY.OTHER_CITY_TARGET_PATH) || '',
    );
    return otherCityTargetPath === '' ? undefined : otherCityTargetPath;
  } catch (e) {
    return undefined;
  }
}

export function setMainCategories({
  topLeftItems,
  topRightItems,
}: {
  topLeftItems: SettingsHomepageItem[];
  topRightItems: SettingsHomepageItem[];
}) {
  writeMigratedItem(safeLocalStorage, STORAGE_KEY.TOP_LEFT_ITEMS, JSON.stringify(topLeftItems));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_TOP_LEFT_ITEMS));

  writeMigratedItem(safeLocalStorage, STORAGE_KEY.TOP_RIGHT_ITEMS, JSON.stringify(topRightItems));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_TOP_RIGHT_ITEMS));
}

export function setLocations({
  cities,
  districts,
  otherCityId,
  otherCityTargetPath,
}: {
  cities: City[];
  districts: District[];
  otherCityId?: number;
  otherCityTargetPath?: string;
}) {
  writeMigratedItem(safeLocalStorage, STORAGE_KEY.CITIES, JSON.stringify(cities));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_CITIES));

  writeMigratedItem(safeLocalStorage, STORAGE_KEY.DISTRICTS, JSON.stringify(districts));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_DISTRICTS));

  writeMigratedItem(safeLocalStorage, STORAGE_KEY.OTHER_CITY_ID, JSON.stringify(otherCityId));
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_DISTRICTS));

  writeMigratedItem(
    safeLocalStorage,
    STORAGE_KEY.OTHER_CITY_TARGET_PATH,
    JSON.stringify(otherCityTargetPath),
  );
  window.dispatchEvent(new Event(WindowDispatchEvent.UPDATE_DISTRICTS));
}
